import React, { useState, useContext, useEffect } from "react";
import "../Styles/UserAccountGridCenter.css";
import { ThemeContext } from "../../../../context/ThemeContext";
import UserFeedCenterLayout from "./UserFeedGridCenter";

const UserPostCentreLayout = ({ pagetype, mediaDisplayMode, userId, profileId, activeTab, setActiveTab }) => {
  const [showOptions, setShowOptions] = useState(false);
  const [coverImage, setCoverImage] = useState("/assets/images/login_page_img2.jpg"); 
  const [openDropdownIndex, setOpenDropdownIndex] = useState(null);
  const [isPostOpen, setIsPostOpen] = useState(true);
  const { theme } = useContext(ThemeContext);

  return (
    <div style={{ height: "auto", maxHeight: "1000vh", marginTop: 0, borderRadius: 20 }}>
        <UserFeedCenterLayout 
          mediaDisplayMode={mediaDisplayMode} 
          userId={userId} 
          profileId={profileId}
          activeFilter={activeTab} 
          setActiveFilter={setActiveTab}
        />
    </div>
  );
};

export default UserPostCentreLayout;
